import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import HelpTip from '../../../../../components/help-tip'
import Modal from '../../../../../components/modal'
import PersonAdd from '@material-ui/icons/PersonAdd';
import { ThemeContext } from 'styled-components'
import { addPortalAccount, loadProfile } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { TrainerLinkButton } from './trainer-link-button'
import { WarningMessage } from '../../../../../components/warning-message';
import { ErrorMessage } from '../../../../../components/error-message';
import { ImportCSV } from './import-csv';

const WhiteCheckbox = withStyles({
})((props) => <Checkbox color="default" {...props} />);


const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  max-width: 540px;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const LinkContainer = styled.div`
  font-weight: 400;
  padding: 0px 12px
  margin: 16px 0;

  >div {
    display: flex;
    align-items: center;

    p {
      padding-left: 2px;
      padding-right: 4px;
    }
  }
`;

const ButtonContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;


const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`;

const ConfirmData = styled.p`
  color: #333 !important;
  margin-bottom: 4px !important;
`;

const AccountsTable = (props) => {
  const theme = useContext(ThemeContext)
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [email, updateEmail] = useState('')
  const [name, updateName] = useState('')
  const [error, updateError] = useState('')
  const [modal1, updateFirstModal] = useState(false)
  const [modal2, updateSecondModal] = useState(false)
  const [showPaymentModal, updatePaymentModal] = useState(false)
  const [checked, setChecked] = useState(false)
  const [linkData, setLinkData] = useState('')

  const handleCloseModals = () => {
    updateFirstModal(false)
    updateSecondModal(false)
  }

  const handleFirstModal = () => {
    if(user.defaultCard.last4 === '' && user.role_id === 1) {
      updatePaymentModal(true)
    } else {
      if (!email || !emailIsValid(email)) {
        updateError('Please enter a valid email')
      } else if (!name) {
        updateError('Please enter a name')
      } else if (((checked && !linkData))) {
        updateError('Please select a trainer')
      } else {
        updateFirstModal(true)
        updateError(false)
      }
    }
  }

  const handleSecondModal = () => {
    if(email !== '' && name !== '' && emailIsValid(email)) {
      user.role_id === 1 ?  updateSecondModal(true) : handleAdd()
      updateError(false)
    } else {
      updateError(true)
    }
  }

  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const clearForm = () => {
    updateEmail('')
    updateName('')
    updateError(false)
    setLinkData('')
    setChecked(false)
  }

  const handleAdd = () => {
    if(email !== '' && name !== '' && emailIsValid(email)) {
      let data = {
        email_address: email,
        name: name,
      }

      if (checked && linkData) {
        data['linked_portal_id'] = linkData.id
      }

      const body = [data]
      addPortalAccount(user.id, body).then((res) => {
        handleCloseModals()
        if(res?.data[0].success) {
          openSnackbar('User successfully added.', false)
        } else {
          openSnackbar(res?.data[0].result, true)
        }
        clearForm()
      
        loadProfile(user.id).then((res) => {
          if (res.data.profile.active === 1) {
            updateUser(res.data.profile)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err) 
        updateError(false)
      })
    } else {
      updateError(true)
    }
  }

  const getPrice = (userCount) => {
    if (user.use_flat_rate) {
      return (user.monthly_flat_rate).toFixed(2)
    } else {
      return (user.account_price * userCount).toFixed(2)
    }
  }

  return (
    <React.Fragment>
      <Container className={props.className}>
        <HeaderContainer>
          <Label>
            <PersonAdd /> Add a New Client
          </Label>
        </HeaderContainer>
        <Input
          error={Boolean(error)}
          label="Email"
          type="email" 
          autoComplete="email" 
          value={email}
          onChange={updateEmail}
        />
        <Input
          error={Boolean(error)}
          label="Full Name"
          value={name}
          onChange={updateName}
        />
        <LinkContainer>
        <div>
          <WhiteCheckbox
            checked={checked}
            onChange={() => setChecked(!checked)}
            inputProps={{ "aria-label": "checkbox" }}
          />
          <p>Change client account to coach account?</p>
          <HelpTip
            message="If you have given a coach app access by adding them as a 'client' you can mark that account as a coach so they can message clients on their app."
          />
        </div>
        </LinkContainer>
        {checked &&
          <TrainerLinkButton
            linkData={linkData}
            setLinkData={setLinkData}
          />
        }
        {(checked && linkData) &&
          <WarningMessage>
            {`This account is intended to be used by a coach. It will be able to view the shared trainer message channels of clients inside of the ${theme.name === 'AVATAR' ? 'Avatar Nutrition' : 'Fit Body Nutrition'} app.`}
          </WarningMessage>
        }
        {error && 
          <ErrorMessage>
            {error}
          </ErrorMessage>
        }
        <ButtonContainer>
          <ImportCSV />
          <ClearButton
            label="Clear"
            onClick={clearForm}
          />
          <AddButton 
            label="Add Client"
            onClick={handleFirstModal}
          />
        </ButtonContainer>
        <Modal
          title="Are you sure this info is correct?"
          submitLabel="Confirm"
          open={modal1}
          onClose={() => updateFirstModal(false)}
          handleSubmit={handleSecondModal}
        >
          <ConfirmData><b>Email:</b> {email}</ConfirmData>
          <ConfirmData><b>Name:</b> {name}</ConfirmData>
          {(checked && linkData) && <ConfirmData><b>Linked to trainer:</b> {linkData.name}</ConfirmData>}
        </Modal>
        <Modal
          title={`Confirmation`}
          message={((user.accounts.length + 1 > user.monthly_peak_basic)) ? 
            `This will bring your total to $${getPrice(user.monthly_peak_basic + 1)}` 
            : 
            `Your total will remain at $${getPrice(user.monthly_peak_basic)}`
          }
          submitLabel="Add User"
          open={modal2}
          onClose={() => updateSecondModal(false)}
          handleSubmit={handleAdd}
        />
        <Modal
          hideAction
          warning
          title="Missing payment information"
          message="Before you can start adding accounts, you must enter a payment method on the My Profile page."
          open={showPaymentModal}
          onClose={() => updatePaymentModal(false)}
        />
      </Container>


  </React.Fragment>
  )
}

export default AccountsTable